var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 48,
    height: 48,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1455_14732",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1455_14732",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAAERklEQVR4nO2dzU4UQRDHfyBwMl7EBIT4ACbqwQuPoB4UIyd9AQwcTNC7cNCzvokfr6ASAb0TNRGMnAzykUiigIeZTaB2Z7d7pme6Zqd+SR0mS9f01H+qu6tndwDDMAzDiM894Bdw3DDbBG4GiB8AA6EcAVvAWEB/dWITuBTCUUhBjgP6qiNBYjkYwokRjqESfYfMPo2UMiJYhijDBFGGCaIME0QZJogyTBBlmCDKiCnIArBD/L0oad8IuDcVE3lh3RgD/nVoo8V+BL5eZ2JmiA2XJeN7xzwCtju0i22uQ1YpGVLmbm/T9rJst7cfMUGUYYIoo0l1SN/UF67UoQ5xqS9csTrE8EN7HRJ6yLI6RBlWhzQBE0QZJogyTBBlmCDKMEGUYYIow0UQ18Irb7tutg98AhaB0RzX1+ICsJT62g/Ut7zXW5iq95uy7DcwnaP/d9H1ZYrCxL6Ak3aInyh30zax+923ghyT7H+5DF8X0JUZzoJUrrAH4yTPTQ5EH546tF0SbQ5SX+Ol9DQb7/hqFqTFE9GHTw5tPos2C6X1rjt9KciY6MOuQ5s90SbWD1K94luXOuSMOHa5MeTf1OJxQCdBBoRp4L44/uLQ5qs4fhCoL0XpGd9eQ1LMIesiyfyRZ1JfFG0OgMepzyrxjm8sQUaAeWAZv+p5Gzjv4H+UpJh09bsPfADm0r6FohaCXCRZKfkuKA6BOx7nmSZfYbhGuOVxYUF6WVFGyCfGNn5itJgm35cpVoHhHOeTeMe3akHmPc61SxKYp7gNU1mMkswpa7Qvh7vZwwLnbKFekGXh7zXVT7SdmADecLpv7wP4VS+IvEMnAvgMxSTtGVoUr/gO0bvWCCFCmf7qRuHaruwh6w06smQSeEv5Q5Y6h3MdfGq12QDXq16QEZLVTuxg97KPlLPs1eeQpOha7eBbi61QXWEY32HKMMk6/x1+tUFZtpf2ZZYwmdHCK34uM750omUHuC54xa8uz0MagwmiDBNEGSaIMkwQZZggyjBBlFGGILdIXk6f9V8D+v3z0vGt1DdP/O1GAz+XeMXPhqwa4pshN0nunA3gRgM/l9heljJsL6vOmCDKMEGUUYUgseuC2tcdkqJPDGPXBVXXHRKrQ/qdohkSuy6ouu6QWB2iDKtD6owJogwTRBkxBWmt72N/QU6amnoji6KrrCw0ilGk3sjC6pB+p6wMaa3vY2dDp+zIU29kETx+u8Lh2RBOG8I5Tsdup1cDlyHrpzi+7N+vxiJjtdWrgYsgq+JYvnfEyEbGaiWE0xlOp90f4EoIx33ONdrf0TITwvEwsC4cf8dE6cZV2hcs6wT8IdAd4Eic4AB4AUxhEz0kMZgCXtKeGUfA7dAnfE77Es7MzZ7liHdPBlPHMlPMsu0ojVmpBfht2ucUs3ZbJ8cwlfdh0zDJvDINXCd5C0LT55F9kv25NeBVan+j9sgwDMNoFP8BuJzUuxT+uT8AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/Blog.b283795273710973764ca14d4a7b9c06.svg";
export { ForwardRef as ReactComponent };